export class CompanyKpi {
    public id: number | null;
    public company_business_line_id: number|null;
    public kpi_id: number|null;
    public valid_from: Date | null;
    public added_by_user_id: number | null;

    constructor(data: CompanyKpiData | void) {
        if (data === undefined) {
            this.id = null;
            this.company_business_line_id = null;
            this.kpi_id = null;
            this.valid_from = null;
            this.added_by_user_id = null;

        } else {
            this.id = data.id;
            this.company_business_line_id = data.company_business_line_id;
            this.kpi_id = data.kpi_id;
            this.valid_from = null;
            if (data.valid_from !== null) {
                this.valid_from = new Date(data.valid_from);
            }
            this.added_by_user_id = data.added_by_user_id;
        }
    }

    serializeData(without_relations: boolean | Array<string> = false) {
        const serialized_data = {
            id: this.id,
            company_business_line_id: this.company_business_line_id,
            kpi_id: this.kpi_id,
            valid_from: this.valid_from,
            added_by_user_id: this.added_by_user_id
        }

        return serialized_data;
    }

    public resetToDefaults(): void {
        this.id = null;
        this.company_business_line_id = null;
        this.kpi_id = null;
        this.valid_from = null;
        this.added_by_user_id = null;
    }
}

export type CompanyKpiData = {
    id: number | null;
    company_business_line_id: number | null;
    kpi_id: number | null;
    valid_from: Date | null;
    added_by_user_id: number | null;
}
